import { mountEmbed } from './embed-core';
import { themePresets } from './src/themes/presets';
import { registerThemePresets } from './src/themes/theme-provider';

// Legacy shared bundle (widget/latest + widget/v{X} CDN channels): ships every
// official preset so existing embeds selecting styleTheme.themeName at runtime
// keep working. New projects should use a per-project variant bundle instead
// (variants/<name>/embed.tsx → widget/<name>/... channels).
registerThemePresets(themePresets);
mountEmbed();
